import { axiosClient } from '@src/api/apiClient/axiosClient';

export const companyUserResendInvitationApiClient = {
  resendInvitation: async (id: number, params: unknown) => {
    return await axiosClient.put(`/tenant/company-users/resend-invitation/${id}`, params);
  },
};
